import theme from '../base'

const iconButton = {
  MuiIconButton: {
    styleOverrides: {
      root: {
        '&:hover': {
          backgroundColor: 'transparent',
          '& svg': { color: theme.palette.primary.main },
        },
      },
    },
  },
}

export default iconButton
